import {StockLevelOverwrite} from '@domain/material-storage'
import {StockDevelopmentData} from '@domain/schedule'
import {dataTestId} from '@hconnect/uikit'
import {Box} from '@mui/material'
import * as d3 from 'd3'
import {Moment} from 'moment-timezone'
import React from 'react'

import {StockDevelopmentChartData} from './StockDevelopmentChartData'
import {StockDevelopmentChartDatetimeLabels} from './StockDevelopmentChartDatetimeLabels'
import {DatetimeValue} from './types'

export interface StockDevelopmentChartContentProps {
  listOfDays: Moment[]
  stockData: StockDevelopmentData & {
    stockOverwrites?: StockLevelOverwrite[]
  }
  stockDataSecondary?: StockDevelopmentData & {
    stockOverwrites?: StockLevelOverwrite[]
  }
  chartRef: React.RefObject<HTMLDivElement>
  minTargetLevels?: {weekend: number; week: number}
  deadStockLevel?: number
  storageCapacity?: number
  height?: number
  width: number
  yLabelWidth?: number
  openStockOverwriteDialog?: (
    datetimeValue: DatetimeValue<string, number>,
    currentOverwrite: StockLevelOverwrite | undefined
  ) => void
  /** Render function for custom indicators (e.g., incoming material indicators) */
  renderIndicators?: (params: {
    xScale: d3.ScaleTime<number, number, never>
    yScale: d3.ScaleLinear<number, number, never>
    stockLevelHourly: Record<string, number>
  }) => React.ReactNode
}

export const STOCK_DEVELOPMENT_CHART_DEFAULT_HEIGHT = 200

export const StockDevelopmentChartContent: React.FC<StockDevelopmentChartContentProps> = ({
  listOfDays,
  stockData,
  stockDataSecondary,
  chartRef,
  openStockOverwriteDialog,
  minTargetLevels,
  deadStockLevel,
  storageCapacity,
  height = STOCK_DEVELOPMENT_CHART_DEFAULT_HEIGHT,
  width,
  yLabelWidth,
  renderIndicators
}) => {
  return (
    <Box sx={{position: 'relative'}} {...dataTestId('stock_development_chart')}>
      <StockDevelopmentChartDatetimeLabels listOfDays={listOfDays} yLabelWidth={yLabelWidth}>
        <StockDevelopmentChartData
          listOfDays={listOfDays}
          stockData={stockData}
          stockDataSecondary={stockDataSecondary}
          minTargetLevels={minTargetLevels}
          openStockOverwriteDialog={openStockOverwriteDialog}
          deadStockLevel={deadStockLevel}
          storageCapacity={storageCapacity}
          height={height}
          width={width}
          chartRef={chartRef}
          renderIndicators={renderIndicators}
        />
      </StockDevelopmentChartDatetimeLabels>
    </Box>
  )
}
